import React, { PropTypes } from 'react';
import { FormGroup, Table, Radio, Checkbox } from 'react-bootstrap';

const CoverageTypeInfo = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <h3 className="ebaoUtil__HeaderThree">Coverage Type Information</h3>
        <FormGroup controlId="mainCoverageType">
        <Table responsive>
          <thead>
            <tr>
              <th colSpan="2">Please choose a main coverage type</th>
              <th>Gross Premium</th>
              <th>Net Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><Radio
                name="coverageType"
                value="comprehensive"
                onChange={props.handleChangeMainCoverageType}
                checked={props.mainCoverType.comprehensive.checked} /></td>
              <td>Comprehensive</td>
              <td>{props.mainCoverType.comprehensive.grossPremium}</td>
              <td>{props.mainCoverType.comprehensive.netPremium}</td>
            </tr>
            <tr>
              <td><Radio
                name="coverageType"
                value="thirdParty"
                checked={props.mainCoverType.thirdParty.checked}
                onChange={props.handleChangeMainCoverageType} /></td>
              <td>Third Party</td>
              <td>{props.mainCoverType.thirdParty.grossPremium}</td>
              <td>{props.mainCoverType.thirdParty.netPremium}</td>
            </tr>
          </tbody>
          </Table>
          <Table responsive>
            <thead>
              <tr>
                <th colSpan="2">Please select add-ons to your coverage</th>
                <th>Gross Premium</th>
                <th>Net Premium</th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td><Checkbox
                  name="carDamageInGuangdongProvinceOfChina"
                  checked={props.addOn.carDamageInGuangdongProvinceOfChina.checked === true}
                  disabled={props.addOn.carDamageInGuangdongProvinceOfChina.disabled === true}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Car Damage in Guangdong Province of China (Excess 15,000 or 15% of loss, whichever is the greater)</td>
                <td>{props.addOn.carDamageInGuangdongProvinceOfChina.grossPremium}</td>
                <td>{props.addOn.carDamageInGuangdongProvinceOfChina.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="thirdPartyLiabilityForTailgateOperation"
                  checked={props.addOn.thirdPartyLiabilityForTailgateOperation.checked === true}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Third Party liability for Tailgate Operation (Limit: up to HKD1M)</td>
                <td>{props.addOn.thirdPartyLiabilityForTailgateOperation.grossPremium}</td>
                <td>{props.addOn.thirdPartyLiabilityForTailgateOperation.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="thirdPartyLiabilityForCraneOperation"
                  checked={props.addOn.thirdPartyLiabilityForCraneOperation.checked === true}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Third Party liability for Crane Operation (Limit: up to HKD1M)</td>
                <td>{props.addOn.thirdPartyLiabilityForCraneOperation.grossPremium}</td>
                <td>{props.addOn.thirdPartyLiabilityForCraneOperation.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="thirdPartyPropertyDamageLimit2M"
                  checked={props.addOn.thirdPartyPropertyDamageLimit2M.checked === true}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Third Party Property Damage Limit Increase to HKD2M</td>
                <td>{props.addOn.thirdPartyPropertyDamageLimit2M.grossPremium}</td>
                <td>{props.addOn.thirdPartyPropertyDamageLimit2M.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="thirdPartyPropertyDamageLimit5M"
                  checked={props.addOn.thirdPartyPropertyDamageLimit5M.checked === true}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Third Party Property Damage Limit Increase to HKD5M</td>
                <td>{props.addOn.thirdPartyPropertyDamageLimit5M.grossPremium}</td>
                <td>{props.addOn.thirdPartyPropertyDamageLimit5M.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="voluntaryExcessForThirdPartyPropertyDamage"
                  checked={props.addOn.voluntaryExcessForThirdPartyPropertyDamage.checked === true}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Discount for Voluntary Third Party Property Damage Excess of HKD1,000</td>
                <td>{props.addOn.voluntaryExcessForThirdPartyPropertyDamage.grossPremium}</td>
                <td>{props.addOn.voluntaryExcessForThirdPartyPropertyDamage.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="tailgate"
                  checked={props.addOn.tailgate.checked}
                  disabled={props.addOn.tailgate.disabled}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Tailgate
                  <input type="number" id="tailgate" autoComplete="off"
                    onChange={props.handleChangeMainCoverageType}
                    value={props.addOn.tailgate.tailgateValue}
                    disabled={props.addOn.tailgate.disabled}
                    min="0" />
                </td>
                <td>{props.addOn.tailgate.grossPremium}</td>
                <td>{props.addOn.tailgate.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="freezer"
                  checked={props.addOn.freezer.checked}
                  disabled={props.addOn.freezer.disabled}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Freezer
                  <input type="number" id="freezer" autoComplete="off"
                    onChange={props.handleChangeMainCoverageType}
                    disabled={props.addOn.freezer.disabled}
                    value={props.addOn.freezer.freezerValue} min="0" />
                </td>
                <td>{props.addOn.freezer.grossPremium}</td>
                <td>{props.addOn.freezer.netPremium}</td>
              </tr>
              <tr>
                <td><Checkbox
                  name="crane"
                  checked={props.addOn.crane.checked}
                  disabled={props.addOn.crane.disabled}
                  onChange={props.handleChangeMainCoverageType} /></td>
                <td>Crane (Excess 20,000 or 20% of loss, whichever is the greater)
                  <input type="number" id="crane" onChange={props.handleChangeMainCoverageType}
                    value={props.addOn.crane.craneValue} autoComplete="off"
                    disabled={props.addOn.crane.disabled}
                    min="0" />
                </td>
                <td>{props.addOn.crane.grossPremium}</td>
                <td>{props.addOn.crane.netPremium}</td>
              </tr>
            </tbody>
            </Table>
        </FormGroup>
    </div>
  )
}

CoverageTypeInfo.propTypes = {
  mainCoverType: PropTypes.object,
  handleChangeMainCoverageType: PropTypes.func,
  addOn: PropTypes.object
};

export default CoverageTypeInfo;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/coverageTypeInfo/CoverageTypeInfo.js